import React, { useContext } from "react";
import * as S from "./style";
import { getData, awardImages } from "./data";
import Image from '../../../../app/js/components/loggedout/common/Image';
import { CTAOfferButton } from "../../common/styled-components/styled-components";
import IllustrationImage from "~images/sem/success-stories/Illustration2.png"
import IllustrationImage3x from "~images/sem/success-stories/illustration-desk.png"
import Star from "~images/sem/main-section/star.png";
import { Link } from "react-router-dom";
import { whiteLilac } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import Routes from '../../routes/routes';
import { SemContext } from "../../context/SemContext";
import Awards from './awards';

const SuccessStories = ({ settings, trackPromoPageEvents }) => {
  const data = getData();
  const { state } = useContext(SemContext);
  const cta_text = (state.settings && state.settings.button_text) || "Try for free";

  return (
    <S.Wrapper>
      <S.ContentTitle>Every 1 in 3 US schools use SplashLearn</S.ContentTitle>
      <S.ContentWrapper>
        <S.StoriesList>
          {data && data.map((item, idx) => {
            return (
              <li key={idx}>{item}</li>
            )
          })}
        </S.StoriesList>
      </S.ContentWrapper>
      <Awards />
      {settings.offer_text && <S.SuccessOfferText>
        <Image src={Star}></Image>
        <span>{settings.offer_text}</span>
        <Image src={Star}></Image>
      </S.SuccessOfferText>
      }
      <S.ButtonWrapper>
        <CTAOfferButton hoverColor={whiteLilac}>
        <Link to={Routes.PURCHASE_ROUTE} onClick={() => trackPromoPageEvents("Promo Page Interacted", {'clicked_on': 'CTA3' }, true)}>
            {cta_text}
          </Link>
        </CTAOfferButton>
      </S.ButtonWrapper>
      <S.IllustrationImageWrapper hideOn="desktop">
        <Image src={IllustrationImage} />
      </S.IllustrationImageWrapper>
      <S.IllustrationImageWrapper hideOn="mobile">
        <Image src={IllustrationImage3x} />
      </S.IllustrationImageWrapper>
    </S.Wrapper>
  );
}

export default SuccessStories;